import { Component, OnInit } from '@angular/core';
import { ChatbotService } from 'src/app/providers/chatbot.service';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrls: ['./chat-modal.component.scss']
})
export class ChatModalComponent implements OnInit {
  
  isChatModalOpen:boolean = false;
  isDropdownOpen = false;

  constructor(private chatService:ChatbotService) { }

  ngOnInit(): void {
    this.chatService.getOpenchatEVent().subscribe(val=>{
      this.isChatModalOpen=val
      // document.body.classList.add("modal-open");
    })
  }
 
  // openChatModal() {
  //   this.isChatModalOpen = !this.isChatModalOpen;
  //   document.body.classList.add("modal-open");
  //   document.getElementById("open-chat-icon").style.display = "none";
    // document.getElementById("close-chat-icon").style.display = "flex";
  // }

  closeChatModal() {
    this.isChatModalOpen = false;
    this.chatService.openChat(false);
    // document.body.classList.remove("modal-open");
    // document.getElementById("open-chat-icon").style.display = "flex";
    // document.getElementById("close-chat-icon").style.display = "none";
  }


toggleDropdown() {
  this.isDropdownOpen = !this.isDropdownOpen;
}

startNewChat() {
  console.log("Starting new chat...");
  this.isDropdownOpen = false;
}

refreshChat() {
  console.log("Refreshing chat...");
  this.isDropdownOpen = false;
}
clearChat(){
  this.chatService.clearChat()
}
}
